/** `'combined'` keys the combined view. Slots without a matching redux key are dropped. */
export default function rekeyPropertyRatesBySlot(
  slotMap: Record<string, Array<App.RawPropertyRoomRates>>,
  reduxKeyBySlot: Record<string, string>,
): Record<string, Array<App.RawPropertyRoomRates>> {
  const out: Record<string, Array<App.RawPropertyRoomRates>> = {}
  for (const [slotKey, rooms] of Object.entries(slotMap)) {
    const reduxKey = reduxKeyBySlot[slotKey]
    if (reduxKey) out[reduxKey] = rooms
  }
  return out
}
